import React from 'react';

function ArrowRightIcon({ variant }) {
  const fillColor = {
    inactive: '#374957',
    active: '#049B56'
  };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" fill="none" viewBox="0 0 23 24">
      <g clipPath="url(#clip0_4213_8556)">
        <path
          fill={fillColor[variant]}
          d="M18.325 18.394l3.756-3.92A3.67 3.67 0 0023.03 12a3.67 3.67 0 00-.95-2.475l-3.756-3.92a1.408 1.408 0 00-1.016-.439c-.382 0-.747.158-1.017.44-.27.28-.421.662-.421 1.06s.151.78.42 1.06l2.665 2.782-17.49.023c-.381 0-.747.158-1.016.439-.27.281-.421.663-.421 1.06 0 .399.151.78.42 1.061.27.282.636.44 1.017.44l17.471-.023-2.646 2.765a1.536 1.536 0 00-.403 1.055c.003.393.155.77.421 1.047.267.279.627.436 1.004.44.377.003.74-.148 1.011-.421h.001z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4213_8556">
          <path fill="#fff" d="M0 0H23V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default ArrowRightIcon;
